import { useContext } from 'react';

import { DescendantsVariantContext } from '../contexts/descendants-variant-context';

export const useDescendantsVariantContext = () => {
  const context = useContext(DescendantsVariantContext);
  if (!context) {
    throw new Error(
      'useDescendantsVariantContext must be used within a DescendantsVariantProvider: ' +
        'you are probably using a component that is part of a multi-part component outside of its parent component.'
    );
  }
  return context;
};
